import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ts-image',
  templateUrl: './ts-image.component.html',
  styleUrls: ['./ts-image.component.scss']
})
export class TsImageComponent {
  @Input() data: any;
}
